import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AdobePageName } from 'src/app/services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from 'src/app/services/adobe-launch/adobe-launch.service';

import { APPLICATION_ROUTES } from '../../../../../constants/application-routes';
import { ContentUtil } from '../../../../../utils/content/content.util';
import { PageComponent } from '../../../page.component';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { ClientSegmentFacadeService } from 'src/app/services/client-segment-observer/client-segment.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BackLinkComponent } from 'src/app/components/back-link/back-link.component';

@Component({
    selector: 'zci-remove-from-account-page-pi',
    templateUrl: './remove-from-account-page-pi.component.html',
    styleUrls: ['./remove-from-account-page-pi.component.scss'],
    imports: [
        BackLinkComponent,
    ],
})
export class RemoveFromAccountPagePIComponent extends PageComponent implements OnInit, OnDestroy {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);
    private readonly activatedRoute = inject(ActivatedRoute);

    readonly grantorContent = ContentUtil.grantorFragmentContent;

    private destroy$ = new Subject<void>();

    appRoutes = APPLICATION_ROUTES;

    backNavigationPath: string | undefined;

    descriptionContent: string

    description: string;

    ngOnInit(): void {

        this.backNavigationPath = this.activatedRoute.snapshot.data?.routePath || this.activatedRoute.snapshot.routeConfig?.path;
        this.adobeLaunchService.pageLoad(AdobePageName.OBSERVABLE_ACCOUNTS_REMOVE_ACCESS_PAGE);
        this.clientSegmentFacadeService.clientSegmentContent$
            .pipe(takeUntil(this.destroy$))
            .subscribe((content: ClientSegmentContentDTO) => {
                this.descriptionContent = `
            <p>${this.grantorContent.edit_remove_user_access.removeYourAccessContactInfo.text1}</p>\n
            <p>${this.grantorContent.edit_remove_user_access.removeYourAccessContactInfo.text2}</p>\n
            <p>${this.grantorContent.edit_remove_user_access.ttyTddContactInfo}</p>\n`

                this.description = this.descriptionContent.replace(
                    '${phone-number}',
                    content?.phoneNumber
                )
            });
    }


    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
